import { render, staticRenderFns } from "./ReporteBI.vue?vue&type=template&id=2794a5ce&scoped=true&"
import script from "./ReporteBI.vue?vue&type=script&lang=js&"
export * from "./ReporteBI.vue?vue&type=script&lang=js&"
import style0 from "./ReporteBI.vue?vue&type=style&index=0&id=2794a5ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2794a5ce",
  null
  
)

export default component.exports